import type { QueryClient } from '@tanstack/react-query';
import { WS_INBOX_MESSAGE_TYPES, WS_MESSAGE_TYPE } from 'cpool-constants';

import { invalidateInboxUnreadQueries } from './invalidateInboxUnreadQueries';
import { queryKeys } from '~/utils/queryKeys';

// Invalidates both unread counts and chat list — structural membership changes on the same events (new chat, auto-link, unlink).
export function handleInboxSocketMessage(
    message: { type?: unknown; event?: unknown },
    queryClient: QueryClient,
    userId: string,
): void {
    if (message.type !== WS_MESSAGE_TYPE.CHAT_INBOX) return;
    if (message.event !== WS_INBOX_MESSAGE_TYPES.INVALIDATE_UNREAD) return;

    queryClient.invalidateQueries({ queryKey: queryKeys.getChats() });
    invalidateInboxUnreadQueries(queryClient, userId);
}
